/*
 * @Description: 合同模板修改
 * @Author: 杨志航
 * @Date: 2026-03-24 15:08:44
 */
import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import HeaderSearch from '@/components/HeaderSearch'
import { Link } from 'react-router-dom'
import { cryptoParamsIntoUrl } from '@/utils'
import Import from '@/components/Import'
import {
  Table,
  Form,
  Select,
  Spin,
  Input,
  Button,
  message,
} from 'antd'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
}
const { Option } = Select
const contractList = [
  { id: 20, name: '客户合同' },
  { id: 21, name: '模板修改合同' },
]

const EditContract = () => {
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [visibleFile, setVisibleFile] = useState(false)
  const ImportRef = useRef()
  const headerSearchRef = useRef()

  useEffect(() => {
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParam = {
      page: pageIndex,
      limit: perPage,
    }
    setPageSize(perPage)
    setPage(pageIndex)
  }

  const getList = values => {
    if (values) {
      const { page, limit } = searchParam
      searchParam = { page, limit, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getEditContractTmpList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  const cols = [
    {
      title: '合同编号',
      dataIndex: 'contract_no',
      align: 'center',
      render: (text, record) => (
        <Link to={cryptoParamsIntoUrl('/protocol/contract/details', { id: text, contractNo: text })}>{text}</Link>
      )
    },
    {
      title: '变更前合同模板',
      dataIndex: 'old_template_name',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '变更后合同模板',
      dataIndex: 'new_template_name',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入人',
      dataIndex: 'operator',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入时间',
      dataIndex: 'import_time',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '导入文件',
      dataIndex: 'file_name',
      align: 'center',
      render: (text, record) => <a href={record.import_file}>{text}</a>
    }
  ]

  const searchItems = [
    {
      label: '合同编号',
      name: 'contract_no',
      component: <Input placeholder='请输入合同编号' />,
    }, {
      label: '导入人',
      name: 'operator',
      component: <Input placeholder='请输入导入人' />,
    }, {
      label: '变更后合同模板',
      name: 'new_template_id',
      component: (
        <Select 
          placeholder='请选择变更后合同模板'
          allowClear
        >
          {contractList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
        </Select>
      ),
    }
  ]

  const onImportFile = () => {
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const onSearch = fileList => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { name, full, url } = fileList[0]
        api.importContractTmp({
          name,
          full,
          relative: url
        }).then(data => {
          message.success('导入成功，请到导入列表查看。')
          ImportRef.current.onLoading()
          setVisibleFile(false)
          headerSearchRef.current.resetFields()
          resetParams()
          getList()
        }).catch(data => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return (
    <div className='vrdevice-stock-container'>
      <Spin spinning={loading} tip='Loading...'>
        <HeaderSearch
          search={searchItems}
          getList={getList}
          resetParams={resetParams}
          hasShowAll={false}
          ref={headerSearchRef}
        ></HeaderSearch>
        <div className='line'></div>
        <div className='vrdevice-stock-btn'>
          <Button type="primary" onClick={onImportFile}>合同模板修改</Button>
        </div>
        <Table
          size='small'
          columns={cols}
          rowKey='id'
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
      </Spin>
      <Import
        title="合同模板修改"
        onSearch={onSearch}
        visibleFile={visibleFile}
        onCloseImport={() => setVisibleFile(false)}
        ImportTemplate="/api/File/DownTemplate?url=/templates/ContractTmpChange.xlsx&name=合同模板修改"
        ImportRef={ImportRef}
      />
    </div>
  )
}

export default Form.create()(EditContract)
